import { SupportedLanguage } from "../interfaces";

/* Supporeted Language browser codes
 * We use these to set default language if `selected_language` is not set in localStorage
 */
export enum FR_LNG_CODES {
  FR = "fr",
  FR_CA = "fr-CA",
  FR_FR = "fr-FR",
  FR_BE = "fr-BE",
  FR_LU = "fr-LU",
  FR_MC = "fr-MC",
  FR_CH = "fr-CH",
}

export enum EN_LNG_CODES {
  EN = "en",
  EN_CA = "en-CA",
  EN_US = "en-US",
  EN_AU = "en-AU",
  EN_BZ = "en-BZ",
  EN_IE = "en-IE",
  EN_JM = "en-JM",
  EN_NZ = "en-NZ",
  EN_PH = "en-PH",
  EN_ZA = "en-ZA",
  EN_TT = "en-TT",
  EN_GB = "en-GB",
  EN_ZW = "en-ZW",
}

export type SUPPORTED_LNG_CODES = typeof FR_LNG_CODES | typeof EN_LNG_CODES;

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  {
    title: "English",
    languageCodes: EN_LNG_CODES,
    code: "en",
  },
  {
    title: "Français",
    languageCodes: FR_LNG_CODES,
    code: "fr",
  },
];

export const DEFAULT_LANGUAGE_CODE = "en";
